export { StarFilledIcon } from "./star-filled";
